/**
 * 공용 확인·알림 다이얼로그 ($j.Ui.Dialog) — swalert(SweetAlert2) 를 대체하는 재사용 컴포넌트.
 *
 * 새 엔진이 아니다. $j.Ui.Modal 위에 '슬롯을 가진 프리셋' 을 얹은 것이다 —
 * 스택(Layer)·백드롭·ESC·스크롤락은 전부 엔진이 이미 한다.
 *
 * [왜 만들었나]
 *   swalert 는 메시지 전체가 title 슬롯 하나로 들어가서, CSS 를 얼마나 발라도
 *   제목/본문 위계를 만들 수 없었다(모바일은 아이콘도 죽인다). 슬롯이 없어서 생긴 한계라
 *   껍데기를 바꾸는 대신 슬롯을 만들었다.
 *
 * [짧은 형 — 기존 swalert 자리]
 *   await $j.Ui.Dialog.alert('저장되었습니다');
 *   if (await $j.Ui.Dialog.confirm('이 오더를 취소할까요?')) { ... }
 *
 * [구조를 가진 형]
 *   $j.Ui.Dialog.open({
 *       tone:  'danger',                 // 배지·강조색: 'danger'|'warn'|'info'|'success' (미지정=배지 없음)
 *       align: 'left',                   // 본문 정렬. 기본은 가운데 — 항목을 줄줄이 세우는 창만 왼쪽 (배지·제목은 늘 가운데)
 *       title: '저단가 발주입니다',        // 텍스트. \n 은 줄바꿈으로 나온다
 *       titleHtml: '<b>3개</b>를 회수할까요?', // 제목 자리에 raw HTML (title 대신). 제목 타이포가 걸린다
 *       desc:  '기준 금액보다 낮아…',      // 보조 문장 (회색)
 *       emph:  '-6차 · 발주개수가 지급되지 않습니다', // 결론 한 줄. desc 가 조건을 말하고 이 줄이 결과를 말한다
 *       rows:  [{ k:'발주 금액', v:'1,200,000원' },
 *               { k:'저단가 하한', v:'1,300,000원', tone:'danger' }],
 *       notes: [{ k:'-6차·발주개수', v:'지급 안 됨' }, '수수료 없음'],
 *       hint:  '금액을 올리면 종전대로 지급됩니다.',
 *       html:  '<p>자유 슬롯</p>',        // 위 슬롯으로 안 되는 것만 (rows 앞에 선다)
 *       htmlAfter: '<label class="ui-dlg-check">…</label>', // 같은 자유 슬롯이지만 rows 뒤에 선다
 *       confirm: '이대로 발주',            // 기본 '확인'
 *       cancel:  '금액 수정',              // 주면 취소버튼이 생긴다 (확인과 같은 폭)
 *       onConfirm(), onCancel(),
 *   });
 *
 * [고르게 하는 형 — choices]
 *   답이 예/아니오가 아니라 '어느 쪽이냐' 일 때. 확인 버튼은 뜨지 않는다 —
 *   고를 것이 곧 실행이라 한 번 더 누를 자리가 없다(있으면 무엇을 골랐는지가 흐려진다).
 *       choices: [{ label:'발주자에게 요청', tag:'페널티 없음',        tone:'good', onPick(){…} },
 *                 { label:'내가 바로 취소',  tag:'대금 10% + 200점 차감', tone:'bad',  onPick(){…} }],
 *       cancel: '닫기',
 *   label = 무엇을 하는가 / tag = 그 대가(옵션) / tone = 'good'|'bad'|'brand'(옵션).
 *   반환은 고르면 true, 닫으면 false. 어느 쪽을 골랐는지는 onPick 이 안다.
 *
 *   rows/confirm 을 하나라도 주면 **고르고 나서 실행하는 형**으로 바뀐다 —
 *   고르면 그 자리에서 대조표가 펼쳐지고(아코디언) 확인 버튼 문구가 그 선택의 말로 바뀐다.
 *   되돌리기 어려운 실행을 창 두 개로 나누지 않고 한 창에서 끝내는 자리다.
 *   설명 문장이 아니라 **표**다 — 무엇을 얼마나 무는지가 숫자로 보여야 고를 수 있다.
 *       choices: [{ label:'내가 바로 취소', tag:'대금 10%', tone:'bad',
 *                   rows:[{ k:'페널티', v:'120,000원', tone:'danger' }],
 *                   confirm:'바로 취소', onPick(){…} }, …],
 *       confirm: '선택하세요',   // 아직 안 고른 동안의 문구 (버튼은 잠겨 있다)
 *   두 선택에 공통인 안내(예: '발주자와 꼭 통화하세요')는 창의 emph 로 한 번만 적는다.
 *
 * [동의를 받고 실행하는 형 — agree]
 *   확인 버튼이 **체크 전까지 잠긴다.** 되돌리기 어렵고 책임이 따라오는 실행에만 쓴다
 *   (읽었다는 표시를 손으로 받는 자리다 — 안내를 한 줄 더 늘리는 용도가 아니다).
 *       agree: '협의 완료, 위 내용 동의',                     // 체크박스만
 *       agree: { label: '협의 완료, 위 내용 동의',
 *                note: '미협의로 생긴 분쟁·손해의 책임은 본인에게 있습니다',
 *                noteHtml: '… <b>본인</b>에게 …' },          // note 대신 raw HTML
 *
 * [입력받기]
 *   const name = await $j.Ui.Dialog.prompt('이름을 입력해주세요', { placeholder:'이름' });
 *   // 취소·닫기면 null. textarea 면 { type:'textarea' }
 *
 *   비었으면 닫지 말아야 하는 칸은 validate 를 준다 — **문장을 돌려주면 안 닫히고**
 *   그 문장이 버튼 위에 뜬다 (빈 문자열·undefined 면 통과):
 *       validate: () => $('#i_bank').val().trim() ? '' : '은행명을 입력해 주세요',
 *
 *   여러 칸이 필요하면 html 슬롯에 직접 짜고 onConfirm 에서 읽는다 (구 Swal preConfirm 자리):
 *   await $j.Ui.Dialog.open({
 *       title:'출금계좌 입력',
 *       html:`<input id="i_bank" class="ui-dlg-input" placeholder="은행명">`,
 *       confirm:'확인', cancel:'취소',
 *       onConfirm(){ const v = $('#i_bank').val(); },   // 닫히기 전에 불린다
 *   });
 *
 * 반환은 Promise<boolean> — 확인이면 true, 취소·닫기면 false.
 * (닫기 ✕·백드롭은 onCancel 을 부르지 않는다. swalert 의 dismiss 동작과 같다)
 *
 * 스타일 정본은 shared/components/_dialog.scss (mobile·devil·admin 이 함께 import).
 */
export default class Dialog {

    /**
     * 사이트 기본값 — 호출마다 안 적어도 늘 붙는 옵션. 지금은 variant 하나.
     *   악덕알리미는 부트스트랩에서 setDefaults({ variant: 'devil' }) 로 'devil' 을 기본으로 둔다 —
     *   글자크기 확대(data-fs)가 .ui-modal--v-devil 에만 걸려서(devil/base/_helpers.scss), 호출부가
     *   variant 를 빼먹으면 그 확인창만 혼자 작게 떴다(2026-10-20 제보하기·로그아웃 확인창).
     *   호출부가 variant 를 직접 주면 그쪽이 이긴다. 다른 사이트(장비불러·관리자)는 안 부르면 종전과 같다.
     */
    defaults = {};

    setDefaults = (d = {}) => { this.defaults = { ...this.defaults, ...d }; return this; };

    /* ───────────────── public ───────────────── */

    /**
     * @return {Promise<boolean>} 확인 true / 취소·닫기 false
     */
    open = (opts = {}) => {
        return new Promise((resolve) => {
            let done = false;// 중복 resolve 방지 (버튼 → close → onClose 순으로 불린다)
            // 콜백이 터져도 **창은 닫히고 Promise 는 풀린다.** 남의 코드를 그대로 부르는
            // 자리라, 거기서 예외가 나면 여기 뒤에 있는 `handle.close()` 가 실행되지 않아
            // 확인창만 화면에 남고 `await` 은 영영 안 풀린다 — 실제로 그렇게 멈춘 적이 있다
            // (짜고치기 판정 뒤 결과창이 안 닫혔다). 사고는 콘솔에 남긴다.
            const settle = (ok, cb) => {
                if (done) return;
                done = true;
                try {
                    if (typeof cb === 'function') cb();
                } catch (e) {
                    console.error('[Dialog] 콜백에서 예외', e);
                }
                resolve(ok);
            };

            const handle = $j.Ui.Modal.open({
                mode:        'center',
                width:       opts.width || '340px',
                maxWidth:    opts.maxWidth,   // 글줄이 긴 창은 폭을 잡아준다 (안 주면 종전과 같다)
                dismissible: opts.dismissible !== false,
                variant:     opts.variant ?? this.defaults.variant,   // 사이트 기본값(setDefaults) — 악덕은 'devil'
                panelClass:  'ui-dlg-panel',
                title:       '',// 제목은 본문 슬롯에서 그린다 (가운데 정렬·배지와 한 덩어리)
                html:        this._bodyHtml(opts),
                onOpen:      (h) => { this._focusFirst(h, opts); if (opts.onOpen) opts.onOpen(h); },
                onClose:     () => settle(false, null),// ✕·백드롭·ESC — 콜백 없음
            });

            // 입력칸에서의 엔터 = 확인. 글자를 다 쓰고 엔터를 치는 것은 어디서나 '보내기'다.
            //
            // **입력칸(text 류)에서만** 받는다 — 아무 데서나 받으면 예/아니오 확인창이 엔터
            // 한 번에 실행돼버린다(그래서 확인창은 포커스도 주지 않는다, _focusFirst 참고).
            // 버튼은 브라우저가 알아서 누르므로 건너뛴다(안 그러면 두 번 눌린다).
            // 패널에 건 핸들러라 창이 닫히면 함께 사라지고, 창 밖의 엔터는 가로채지 않는다.
            handle.el.on('keydown', (e) => {
                if (e.key !== 'Enter') return;
                if (!this._isTypable(e.target)) return;                     // 버튼·셀렉트·체크박스 등
                if (String(e.target.tagName).toLowerCase() === 'textarea') return;  // 여러줄은 줄바꿈이 먼저다
                // 한글 조합 중의 엔터는 글자를 확정하는 키다 — 창을 닫으면 안 된다
                if ((e.originalEvent && e.originalEvent.isComposing) || e.which === 229) return;
                e.preventDefault();
                handle.el.find('.ui-dlg__ok').trigger('click');
            });

            // 반드시 답해야 하는 창(동의 등)은 ✕ 도 없앤다 — 백드롭·ESC 는 엔진이 이미 막는다.
            // 구 Swal 의 allowOutsideClick:false + allowEscapeKey:false 자리.
            if (opts.dismissible === false) handle.el.find('.ui-modal__close').remove();

            // 고르고 나서 실행하는 선택지형에서 지금 고른 것 (_isExpandable 참고)
            let picked = null;

            handle.el.find('.ui-dlg__ok').on('click', () => {
                // 닫기 전에 막을 기회 — 구 Swal 의 preConfirm 자리.
                // 문자열을 돌려주면 그 문장을 창 안에 띄우고 **닫지 않는다**.
                if (typeof opts.validate === 'function') {
                    const err = opts.validate(handle.el);
                    if (err) {
                        handle.el.find('.ui-dlg__err').text(err).show();
                        return;
                    }
                }
                settle(true, opts.onConfirm);
                handle.close();
                // 창을 닫은 뒤에 실행한다 — 뒤이어 알림이 뜨는 경우가 많은데 겹치면 읽기 어렵다
                if (picked && typeof picked.onPick === 'function') picked.onPick();
            });
            // 고치기 시작하면 지적은 치운다 — 빨간 줄이 남아 있으면 이미 고친 뒤에도 혼난 기분이 든다
            if (opts.validate) {
                handle.el.on('input change', 'input, textarea, select', () => {
                    handle.el.find('.ui-dlg__err').hide();
                });
            }

            // 동의 게이트 — 체크 전에는 [확인]을 잠근다. validate 로 막는 것과 다르다:
            // 눌러본 뒤에 혼나는 게 아니라, 무엇을 해야 열리는지 먼저 보여준다.
            if (opts.agree) {
                const $ok = handle.el.find('.ui-dlg__ok');
                const sync = () => $ok.prop('disabled', !handle.el.find('.ui-dlg__agree-chk').is(':checked'));
                handle.el.on('change', '.ui-dlg__agree-chk', sync);
                sync();
            }

            handle.el.find('.ui-dlg__cancel').on('click', () => {
                settle(false, opts.onCancel);
                handle.close();
            });

            // ── 선택지 ──
            if (opts.choices && opts.choices.length) {
                const expandable = this._isExpandable(opts);
                const $choices = handle.el.find('.ui-dlg__choice');

                if (!expandable) {
                    // 바로 실행하는 형 — 창을 먼저 닫고 실행한다. 확인창이 이어지는 경우가 많은데
                    // 겹쳐 뜨면 뒤 카드가 읽혀 무엇을 고른 건지 흐려진다.
                    $choices.on('click', (e) => {
                        const pick = opts.choices[$(e.currentTarget).data('i')];
                        // 먼저 '골랐다'(true)로 매듭짓고 닫는다 — 닫기가 먼저면 onClose 가 false 로
                        // 먼저 풀어버려, `await` 하는 쪽은 무엇을 골라도 '닫음' 을 받는다
                        settle(true, null);
                        handle.close();
                        if (pick && typeof pick.onPick === 'function') pick.onPick();
                    });
                } else {
                    // 고르고 나서 실행하는 형 — 고른 것만 펼치고, 확인 버튼이 그 선택의 말을 한다.
                    const $ok = handle.el.find('.ui-dlg__ok');
                    $choices.on('click', (e) => {
                        const $c = $(e.currentTarget);
                        $choices.removeClass('is-on').attr('aria-expanded', 'false');
                        $c.addClass('is-on').attr('aria-expanded', 'true');
                        picked = opts.choices[$c.data('i')];
                        $ok.prop('disabled', false)
                           .text(picked.confirm || opts.confirm || '확인');
                    });
                }
            }
        });
    }

    /** 알림 — 확인 버튼 하나. @return {Promise<boolean>} 항상 true */
    alert = (msg, opts = {}) => this.open({ ...opts, title: msg, cancel: null });

    /** 확인 — 확인/취소 두 버튼. @return {Promise<boolean>} */
    confirm = (msg, opts = {}) => this.open({ cancel: '취소', ...opts, title: msg });

    /**
     * 입력받기 — 한 칸짜리. 구 Swal.fire({input:'text'}) 자리.
     * @param {string} msg 제목
     * @param {{type?:'text'|'textarea'|'number', value?:string, placeholder?:string, label?:string}} opts
     * @return {Promise<string|null>} 취소·닫기면 null
     */
    prompt = async (msg, opts = {}) => {
        const id = 'ui-dlg-in-' + Math.random().toString(36).slice(2, 8);
        const type = opts.type || 'text';
        const val = this._esc(opts.value == null ? '' : opts.value);
        const ph = this._esc(opts.placeholder || '');
        const label = opts.label ? `<label class="ui-dlg-inlabel" for="${id}">${this._esc(opts.label)}</label>` : '';
        const field = type === 'textarea'
            ? `<textarea id="${id}" class="ui-dlg-input" rows="6" placeholder="${ph}">${val}</textarea>`
            : `<input id="${id}" class="ui-dlg-input" type="${type === 'number' ? 'number' : 'text'}" value="${val}" placeholder="${ph}">`;

        let out = null;
        const ok = await this.open({
            ...opts,
            title:     msg,
            html:      label + field,
            cancel:    opts.cancel === null ? null : (opts.cancel || '취소'),
            onConfirm: () => { out = $('#' + id).val(); if (opts.onConfirm) opts.onConfirm(out); },
            onOpen:    () => { const el = document.getElementById(id); if (el) { el.focus(); el.select?.(); } },
        });
        return ok ? out : null;
    };

    /* ───────────────── internal ───────────────── */

    /**
     * 열자마자 포커스를 준다 — **엔터·스페이스만 눌러도 창이 닫히게** 하려는 것이다.
     * 키로 버튼을 누르는 일은 브라우저가 하므로, 우리가 할 일은 표적을 정해주는 것뿐이다.
     *
     * ⚠ **예/아니오를 묻는 확인창(취소 버튼이 있는 창)은 표적을 주지 않는다.** 탈퇴·삭제처럼
     *   되돌리기 어려운 물음이 엔터·스페이스 한 번에 실행되면 안 된다 — 물음을 읽고 손으로
     *   고르라고 띄운 창이다. 그런 창에서 엔터는 종전처럼 아무 일도 하지 않는다.
     *
     * 그래서 표적은 둘 중 하나다 —
     *   · 알림창(확인 하나뿐)          → [확인]. 엔터·스페이스로 바로 닫힌다
     *   · 글자를 받는 칸이 있는 창       → 그 칸. 쓰라고 연 창이고, 거기서 엔터는 위 keydown 이
     *                                     확인으로 받는다 (이미 타이핑한 사람의 엔터라 오발이 아니다)
     * 체크박스·라디오·셀렉트는 표적으로 삼지 않는다 — 스페이스가 확인이 아니라 그 칸을
     * 건드리게 되고, 셀렉트는 엔터도 먹지 않는다.
     * prompt() 처럼 호출부가 스스로 포커스를 옮기는 창은 그쪽이 나중에 불려 이긴다.
     */
    _focusFirst(handle, opts) {
        const el = handle.el[0];
        if (!el) return;
        const typed = [...el.querySelectorAll('.ui-dlg__html input, .ui-dlg__html textarea')]
            .find((n) => this._isTypable(n));
        // 취소가 있는 창(=확인창)은 입력칸이 없으면 아무 데도 포커스를 주지 않는다
        const target = typed || (opts.cancel ? null : el.querySelector('.ui-dlg__ok'));
        // preventScroll — 포커스 때문에 뒤 화면이 움직이면 창이 튀어 보인다
        if (target) target.focus({ preventScroll: true });
    }

    /** 글자를 받는 칸인가 — textarea 와 text 류 input 만 (체크박스·라디오·버튼·셀렉트 제외) */
    _isTypable(node) {
        if (!node || !node.tagName) return false;
        const tag = node.tagName.toLowerCase();
        if (tag === 'textarea') return true;
        if (tag !== 'input') return false;
        const TYPEABLE = ['', 'text', 'tel', 'number', 'email', 'search', 'password', 'url', 'date'];
        return TYPEABLE.includes(String(node.getAttribute('type') || '').toLowerCase());
    }

    _bodyHtml(opts) {
        const tone = opts.tone || '';
        const parts = [];

        if (tone) parts.push(`<div class="ui-dlg__badge">${this._badgeChar(tone)}</div>`);
        if (opts.title) parts.push(`<h4 class="ui-dlg__title">${this._esc(opts.title)}</h4>`);
        // 제목 자리의 raw HTML — 레거시 swalert 의 '제목에 태그가 든' 호출이 여기로 온다.
        // html 슬롯(작은 회색 본문)으로 보내면 제목이어야 할 문장이 강등된다.
        if (opts.titleHtml) parts.push(`<div class="ui-dlg__titlehtml">${opts.titleHtml}</div>`);
        if (opts.desc) parts.push(`<p class="ui-dlg__desc">${this._esc(opts.desc)}</p>`);
        if (opts.emph) parts.push(`<p class="ui-dlg__emph">${this._esc(opts.emph)}</p>`);
        if (opts.html) parts.push(`<div class="ui-dlg__html">${opts.html}</div>`);
        if (opts.rows && opts.rows.length) parts.push(this._rowsHtml(opts.rows));
        if (opts.notes && opts.notes.length) parts.push(this._notesHtml(opts.notes));
        if (opts.choices && opts.choices.length) parts.push(this._choicesHtml(opts.choices, this._isExpandable(opts)));
        // 표를 읽고 나서 고르는 것 (실행에 딸린 곁가지 체크박스 등) — html 은 rows '앞' 이라
        // 근거보다 선택지가 먼저 서게 된다. 그 자리를 뒤에도 하나 둔다.
        if (opts.htmlAfter) parts.push(`<div class="ui-dlg__html">${opts.htmlAfter}</div>`);
        if (opts.hint) parts.push(`<p class="ui-dlg__hint">${this._esc(opts.hint)}</p>`);
        if (opts.agree) parts.push(this._agreeHtml(opts.agree));
        // validate 가 돌려준 문장이 들어갈 자리 (평소엔 비어 숨어 있다)
        if (opts.validate) parts.push('<p class="ui-dlg__err" style="display:none"></p>');
        parts.push(this._btnsHtml(opts));

        const mods = (tone ? ' ui-dlg--' + tone : '') + (opts.align === 'left' ? ' ui-dlg--left' : '');
        return `<div class="ui-dlg${mods}">${parts.join('')}</div>`;
    }

    _rowsHtml(rows) {
        const li = rows.map((r) => {
            const t = r.tone ? ` is-${r.tone}` : '';
            return `<div class="ui-dlg__row${r.weak ? ' is-weak' : ''}">`
                + `<dt>${this._esc(r.k)}</dt><dd class="${t.trim()}">${this._esc(r.v)}</dd></div>`;
        }).join('');
        return `<dl class="ui-dlg__rows">${li}</dl>`;
    }

    _notesHtml(notes) {
        const li = notes.map((n) => {
            if (typeof n === 'string') return `<li><span>${this._esc(n)}</span></li>`;
            return `<li><span>${this._esc(n.k)}</span><b>${this._esc(n.v)}</b></li>`;
        }).join('');
        return `<ul class="ui-dlg__notes">${li}</ul>`;
    }

    /**
     * 동의 게이트 — 경고문 한 덩어리와 체크박스. 체크될 때까지 [확인]이 잠긴다(open 참고).
     * @param {string|{label?:string,note?:string,noteHtml?:string}} agree
     */
    /**
     * 동의 게이트 — 경고문 한 덩어리와 체크박스. 체크될 때까지 [확인]이 잠긴다(open 참고).
     * @param {string|{label?:string,note?:string,noteHtml?:string}} agree
     */
    _agreeHtml(agree) {
        const o = typeof agree === 'string' ? { label: agree } : (agree || {});
        const note = o.noteHtml ? `<p class="ui-dlg__agree-note">${o.noteHtml}</p>`
            : (o.note ? `<p class="ui-dlg__agree-note">${this._esc(o.note)}</p>` : '');
        const label = this._esc(o.label || '위 내용에 동의합니다');
        return `<div class="ui-dlg__agree">${note}`
            + `<label class="ui-dlg-check"><input type="checkbox" class="ui-dlg__agree-chk"><b>${label}</b></label>`
            + `</div>`;
    }

    _btnsHtml(opts) {
        const cancel = opts.cancel ? `<button type="button" class="ui-dlg__cancel">${this._esc(opts.cancel)}</button>` : '';
        // 바로 실행하는 선택지형은 확인 버튼이 없다 — 고르는 것이 곧 실행이라 확인할 대상이 없다.
        // (cancel 만 남으므로 버튼줄은 '닫기' 한 칸이 된다)
        if (opts.choices && opts.choices.length && !this._isExpandable(opts)) {
            return `<div class="ui-dlg__btns">${cancel}</div>`;
        }
        const ok = this._esc(opts.confirm || '확인');
        // 고르고 실행하는 형은 아직 고른 것이 없으니 잠가 둔다 (문구는 고를 때 바뀐다)
        const lock = this._isExpandable(opts) ? ' disabled' : '';
        return `<div class="ui-dlg__btns">${cancel}<button type="button" class="ui-dlg__ok"${lock}>${ok}</button></div>`;
    }

    /** 선택지가 설명·버튼문구를 들고 있으면 '고르고 나서 실행하는' 형이다 */
    _isExpandable(opts) {
        return !!(opts.choices && opts.choices.some((c) => (c.rows && c.rows.length) || c.confirm));
    }

    /**
     * 선택지 — 카드 하나가 곧 버튼이다. tag(대가)를 제목 옆에 세워 무엇을 고르는지 먼저 읽히게 한다.
     * @param {{label:string, tag?:string, tone?:'good'|'bad'|'brand'}[]} choices
     */
    _choicesHtml(choices, expandable) {
        const li = choices.map((c, i) => {
            const tone = c.tone ? ` ui-dlg__tag--${c.tone}` : '';
            const tag = c.tag ? `<em class="ui-dlg__tag${tone}">${this._esc(c.tag)}</em>` : '';
            const head = `<span class="ui-dlg__choice-head"><b>${this._esc(c.label)}</b>${tag}</span>`;
            // 대조표는 접힌 채로 함께 그려 둔다 — 고를 때 펼치기만 하면 된다
            const detail = (c.rows && c.rows.length)
                ? `<span class="ui-dlg__detail">${this._rowsHtml(c.rows)}</span>` : '';
            const aria = expandable ? ' aria-expanded="false"' : '';
            return `<button type="button" class="ui-dlg__choice" data-i="${i}"${aria}>${head}${detail}</button>`;
        }).join('');
        return `<div class="ui-dlg__choices${expandable ? ' is-expandable' : ''}">${li}</div>`;
    }

    _badgeChar(tone) {
        return { danger: '!', warn: '!', info: 'i', success: '✓' }[tone] || '!';
    }

    _esc(s) {
        return String(s == null ? '' : s)
            .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }
}
